<ion-tabs>

  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="checklist" (click)="gotoChecklistAndReload()">
      <ion-icon  name="document"></ion-icon>
      <ion-label>Checklist</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="currentTabPosition<1" tab="organisation" (click)="changeTabPosition(1)" href="/page/organisation">
      <ion-icon  name="book"></ion-icon>
      <ion-label>Organisation</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="currentTabPosition<2" tab="address" (click)="changeTabPosition(2)" href="/page/address">
      <ion-icon  name="map"></ion-icon>
      <ion-label>Address</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="currentTabPosition<3" tab="parties" (click)="changeTabPosition(3)" href="/page/parties">
      <ion-icon  name="people"></ion-icon>
      <ion-label>Parties</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="currentTabPosition<4" tab="risk" (click)="changeTabPosition(4)" href="/page/risk">
      <ion-icon  name="alert-sharp"></ion-icon>
      <ion-label>Risk</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="currentTabPosition<5" tab="declaration" (click)="changeTabPosition(5)" href="/page/declaration">
      <ion-icon  name="accessibility"></ion-icon>
      <ion-label>Declaration</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="faq" href="/page/faq">
      <ion-icon  name="help-sharp"></ion-icon>
      <ion-label>FAQ</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
